import React from "react";
import { Link } from "react-router-dom";
import { getUserDetails } from "../content/axiosConfig.js";

const HeaderUser = () => {
  const user = getUserDetails() || {};
  const { FullName = "User", Email = "" } = user;

  return (
    <Link to="/profile" className="donezo-header-user">
      <div className="donezo-user-info">
        <div className="donezo-user-name">{FullName}</div>
        <div className="donezo-user-email">{Email}</div>
      </div>
    </Link>
  );
};

export default HeaderUser;
